import { EventEmitter, OnChanges, OnDestroy } from '@angular/core';
import { TemplateRef } from '@angular/core';
import { ViewChild } from '@angular/core';
import { SimpleChanges } from '@angular/core';
import { Component, Input, OnInit, Output } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { ServiceMessageComponent } from '@core/components/service-message/service-message.component';
import { DEFAULT_DIALOG_CONFIG, SereviceMessageType } from '@core/constants/serviceMessage.const';
import { IApp } from '@core/models/app.interfaces';
import { LookupService } from '@core/services/lookup.service';
import { FormlyFieldConfig, FormlyFormOptions, FormlyModule } from '@ngx-formly/core';
import { TranslateService } from '@ngx-translate/core';
import { AUTO_WIDTH_FOR_COLUMNS } from '@shared/models/table-view.model';
import { FormFactoryService } from '@shared/services/form-factory.service';
import { ModalService } from '@shared/services/modal.service';
import { TableTemplateControls } from '@shared/services/table-template-controls.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SOURCE_DATA_TYPE } from '../stepper/stepper.const';
import { TableViewComponent } from '../table-view/table-view.component';
import { GenericActionControlComponent } from '@shared/controls/generic-action-control/generic-action-control.component';
import { CommonModule } from '@angular/common';
import { DictPipe } from '@shared/pipes/dict.pipe';

@Component({
  selector: 'app-simple-formly-table-add-remove',
  templateUrl: './simple-formly-table-add-remove.component.html',
  styleUrls: ['./simple-formly-table-add-remove.component.scss'],
  imports: [FormlyModule, TableViewComponent, GenericActionControlComponent, FormlyModule,
    ReactiveFormsModule, CommonModule, DictPipe ]
})
export class SimpleFormlyTableAddRemoveComponent implements OnInit, OnDestroy, OnChanges {

  private _destroy$ = new Subject<any>();

  @ViewChild('dropDownDataTemplate', {static: true}) public dropDownDataTemplate: TemplateRef<any>;
  @ViewChild('actionTemplate', { static: true }) public actionTemplate: TemplateRef<any>;
  @Input() inputFormFields: any;
  @Input() tableConfigRaw: any;
  @Input() actionList: any[];
  @Output() tableContent = new EventEmitter<any>();
  @Input() tableData: any[];
  @Input() errorCheckCallback;
  @Input() disabled: boolean;
  @Input() disableOneRowSelection = false;

  model: any={};
  formGroup = new FormGroup({});
  fields: FormlyFieldConfig[];
  options: FormlyFormOptions = {};

  dataList = new IApp.ISimpleTableData();
  itemsToBeRemoved: any[]=[];
  readonly: boolean = true;
  tableConfig: any;

  ciEngSrc: IApp.ILookup[];

  addToTableBtn = {
    groupFields: false,
    fieldGroup:[
        {
            type: 'button',
            id:'addrow',
            key: 'addrow',
            className:'ml-3',
            required: true,
            label: 'SUBMISSION_MANAGEMENT_MODULE.ci_info.field_18',
            disabled: false
        },
        {
          type: 'button',
          id:'removeRow',
          key: 'removeRow',
          className:'ml-3',
          required: true,
          label: 'SUBMISSION_MANAGEMENT_MODULE.ci_info.field_19',
          disabled: false
      },
    ]
  }

  updateToTableBtn = {
    groupFields: false,
    fieldGroup:[
        {
            type: 'button',
            id:'updateRow',
            key: 'updateRow',
            className:'ml-3',
            required: true,
            label: 'SUBMISSION_MANAGEMENT_MODULE.ci_info.field_39',
        },
        {
          type: 'button',
          id:'cancelRow',
          key: 'cancelRow',
          className:'ml-3',
          required: true,
          label: 'SUBMISSION_MANAGEMENT_MODULE.ci_info.field_40',
      },
    ]
  }

  constructor(
    private modalService: ModalService,
    private lookupService: LookupService,
    private translateService: TranslateService,
    private formFactoryService:FormFactoryService,
    private tableTemplateControls:TableTemplateControls
  ) { }

  ngOnInit() {
    this.initLookUp();
    this.formBtnCtrlCallBack();
    this.actionsTable();
  }

  ngOnChanges(changes: SimpleChanges) {
    this.resetVariableMembers();
    this.appendAddRowBtn();
    this.adjustFieldsCSS();
    this.processRawTableConfig();
    this.prePopulateTable();
    this.inputFormFields = changes.inputFormFields && changes.inputFormFields.currentValue;
    this.createFields();

    if (this.disabled) {
      setTimeout(() => this.formGroup.disable())
    }

  }

  actionsTable() {
    this.tableTemplateControls._action.subscribe( metadata => {

      if(metadata.action.workflowAction === 'VIEW'){
        //eventually a view link would be used, considering that this is generic this comp itself
        //then we can't tie down anything here specific to any scenario, another logic/engine has to be develop
        //to handle any specific parent services from here
      } else {
        switch(metadata.action.workflowAction) {
          case 'EDIT':
            this.editRow(metadata.data);
            break;
        }
      }

    });
  }

  createFields() {
    if (this.disabled) {
      this.inputFormFields = [];
    }
    this.fields = this.formFactoryService.configureForm(this.inputFormFields);
  }

  editRow(data) {
    this.removeControlBtns();
    this.appendUpdateRowBtn();
    this.createFields();
    this.model.id = data.id;
    this.model.name = data.name;
    this.model.quantity = data.quantity;
    this.model.dataKey = data.dataKey;
  }

  prePopulateTable() {
    if(this.tableData !== undefined) {
      this.dataList.content = this.tableData.map((data, index) => {
        return {
          ...data,
          dataKey: data.id + index + data.name
        }
      });
    }
  }

  processRawTableConfig(){
    this.tableConfigRaw.columns.forEach(col => {
      if(col.useDropDownTemplate) {
        col.templateRef = this.dropDownDataTemplate;
      }
    });
    this.tableConfig = this.tableConfigRaw;

    if(this.actionList.length && !this.hasTableActionCol()){
      this.tableConfig.columns.push({
        header: 'actions',
        width: AUTO_WIDTH_FOR_COLUMNS,
        templateRef: this.actionTemplate,
      });
    }
  }

  hasTableActionCol(){
    return this.tableConfig.columns.find(col=> {return col.header === 'actions'});
  }

  getDictionary(col) {
    //this can defenitly be improved no time to think more of this exhusted,
    //but the dictionary var can be populated better rather than creating multiple lists
    //may be the most common lookup services can be query onload of the application, async and provide it in a service
    //to supply comps
    var dictionary;

    switch(col.dictionary) {
      case SOURCE_DATA_TYPE.LOOKUP_TYPE_OF_ENERGY:
        dictionary = this.ciEngSrc;
      break;
    }

    return dictionary;
  }

  translateField(field) {
    return this.translateService.instant(`${this.tableConfigRaw.translationPrefix}.${field}`);
  }

  resetVariableMembers() {
    this.model = {};
    this.fields = null;
    this.formGroup = new FormGroup({});
    //this.dataList.content = [];
  }

  adjustFieldsCSS() {
    var width = 12 / (this.inputFormFields[0].fieldGroup.length);

    this.inputFormFields[0].fieldGroup.forEach(element => {
      element.className = 'col-'+ width.toString();
    });

  }

  appendUpdateRowBtn(){
    if(this.inputFormFields[1] === undefined)
      this.inputFormFields.push(this.updateToTableBtn);
  }

  appendAddRowBtn(){
    if(this.inputFormFields[1] === undefined) {
      this.addToTableBtn.fieldGroup.forEach(group => group.disabled = this.disabled);
      this.inputFormFields.push(this.addToTableBtn);
    }
  }

  removeControlBtns(){
    this.inputFormFields.splice( 1, 1);
  }

  formBtnCtrlCallBack(){
    this.formFactoryService.buttonCallback
      // .pipe(takeUntil(this._destroy$))
      .subscribe(
      data => {

        switch(data.field.key) {
          case 'cancelRow':
            this.cancelData();
            break;
          case 'updateRow':
            this.updateData();
            break;
          case 'removeRow':
            if (this.itemsToBeRemoved.length) {
              this.removeItems();
            }
            break;
          case 'addrow':
            this.addData();
            break;
        }
      }
    );
  }

  private markFormGroupDirty(formGroup: FormGroup) {
    (<any>Object).values(formGroup.controls).forEach((control) => {
      control.markAsDirty();

      if (control.controls) {
        this.markFormGroupDirty(control);
      }
    });
  }

  addData() {

    if(!this.formGroup.valid) {
      this.markFormGroupDirty(this.formGroup);
      return;
    }

    if (!this.errorCheckCallback(this.model.id, this.ciEngSrc)) {
      const content = this.dataList.content;
      content.push(
        {
          dataKey: this.model.id + this.dataList.content.length + this.model.name,
          id: this.model.id,
          name: this.model.name,
          quantity: this.model.quantity,
          entityActionList: this.actionList,
        },
      );
      this.dataList = { ...this.dataList, content };
      this.formGroup.reset();

      this.emitTableContent();

    }
  }

  updateData() {
    const content = this.dataList.content;
    const idx = content.findIndex(el => el.dataKey === this.model.dataKey);
    if (idx > -1) {
      content[idx] = {
        id: this.model.id,
        name: this.model.name,
        quantity: this.model.quantity,
        entityActionList: this.actionList,
      };
    }
    this.dataList = { ...this.dataList, content };

    this.formGroup.reset();
    this.emitTableContent();
    this.removeControlBtns();
    this.appendAddRowBtn();
    this.createFields();
  }

  cancelData(){
    this.formGroup.reset();
    this.removeControlBtns();
    this.appendAddRowBtn();
    this.createFields();
  }

  getSelections(event) {
    this.itemsToBeRemoved = event;
  }

  removeItems() {
    const items = this.itemsToBeRemoved.map(item => {
      const energy = this.ciEngSrc.find(engSrc => engSrc.id === item.id).name;
      return this.translateService.instant(`SUBMISSION_MANAGEMENT_MODULE.ci_info.${energy}`);
    }).join(', ');

    this.modalService
      .open(
        ServiceMessageComponent,
        {
          messages: null,
          message: 'confirmEnergySourceRemove',
          metaDataList: [items],
          type: SereviceMessageType.WARNING,
        },
        true,
        DEFAULT_DIALOG_CONFIG
      )
      .afterClosed()
      .subscribe((result?: any) => {
        if (result) {
          const content = this.dataList.content;
          this.itemsToBeRemoved.forEach(item => {
            content.splice( this.dataList.content.indexOf(item), 1);
          });
          this.itemsToBeRemoved = [];
          this.dataList = { ...this.dataList, content };

          this.emitTableContent();
        }
      });
  }

  ngOnDestroy() {
    this.resetVariableMembers();
  }

  emitTableContent() {
    this.tableContent.emit(this.dataList);
  }

  initLookUp() {
    this.lookupService.getTypeOfEnergy().pipe(
      takeUntil(this._destroy$),
    ).subscribe(resp => {
      this.ciEngSrc=resp;
    });
  }

}
